import { itemFields } from 'src/enums/time-tracker';
import { getColumnWidths } from 'src/common/table/column-utils';
import { getFields, TTimeTrackerField } from './get-tt-fields';

const columnWidthGroup: Record<'minimum' | 'medium' | 'maximum', TTimeTrackerField[]> = {
  minimum: [
    itemFields.AFE,
    itemFields.ESTIMATE,
    itemFields.P90,
    itemFields.ACTUAL,
    itemFields.NPT,
    itemFields.WOW,
    itemFields.VARIANCE,
    itemFields.PLANNED_DEPTH,
    itemFields.ACTUAL_DEPTH,
  ],
  medium: [itemFields.SECTION, itemFields.OPERATION, itemFields.ACTIVITY],
  maximum: [itemFields.NAME, itemFields.START, itemFields.FINISH],
};

const getFieldWidth = (field: TTimeTrackerField) => {
  if (columnWidthGroup.minimum.includes(field)) {
    return 1;
  }
  if (columnWidthGroup.medium.includes(field)) {
    return 1.5;
  }
  if (columnWidthGroup.maximum.includes(field)) {
    return 2;
  }
  return 1;
};

export const getColumnWidth = (disabledFields: string[] = []) => {
  const fields = getFields(disabledFields);
  return getColumnWidths(fields, getFieldWidth, itemFields.NAME);
};
